(function(){
  const $nav = {
    toggle: document.querySelector('.js-st-Header__toggle'),
    body: document.querySelector('.js-st-Header__nav'),
    cover: document.querySelector('.js-st-Header__navCover'),
    megaTrigger: document.querySelector('.js-st-Header__linkTrigger'),
    megaMenu: document.querySelector('.js-st-Header__linkCategory')
  }

  const $body = document.body;

  $nav.cover.onclick = function(){
    if($nav.toggle.classList.contains('is-active')) {
      $body.classList.remove('is-noscroll');
      $nav.toggle.classList.remove('is-active');
      $nav.body.classList.remove('is-show');
    }
  }

  $nav.toggle.onclick = function() {

    if($nav.toggle.classList.contains('is-active')) {
      $body.classList.remove('is-noscroll');
      $nav.toggle.classList.remove('is-active');
      $nav.body.classList.remove('is-show');

    } else {
      $body.classList.add('is-noscroll');
      $nav.body.classList.add('is-show');
      $nav.toggle.classList.add('is-active');
    }
  }

  $nav.megaTrigger.addEventListener('mouseover', function(){
    this.classList.add('is-show');
  });

  $nav.megaTrigger.addEventListener('mouseleave', function(){
    this.classList.remove('is-show');
  });

})();